export default __webpack_public_path__ + "static/media/res3.d3465957.PNG";